import * as React from "react";

import { JSX } from "react/jsx-runtime";

const EditIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="dashboard-circle-edit">
      <path
        id="Vector"
        d="M6.75 10.5001C9.09721 10.5001 11 8.59733 11 6.25012C11 3.90291 9.09721 2.00012 6.75 2.00012C4.40279 2.00012 2.5 3.90291 2.5 6.25012C2.5 8.59733 4.40279 10.5001 6.75 10.5001Z"
        stroke="#08090A"
        strokeWidth={1.5}
      />
      <path
        id="Vector_2"
        d="M18.25 22.0001C20.5972 22.0001 22.5 20.0973 22.5 17.7501C22.5 15.4029 20.5972 13.5001 18.25 13.5001C15.9028 13.5001 14 15.4029 14 17.7501C14 20.0973 15.9028 22.0001 18.25 22.0001Z"
        stroke="#08090A"
        strokeWidth={1.5}
      />
      <path
        id="Vector_3"
        d="M6.75 22.0001C9.09721 22.0001 11 20.0973 11 17.7501C11 15.4029 9.09721 13.5001 6.75 13.5001C4.40279 13.5001 2.5 15.4029 2.5 17.7501C2.5 20.0973 4.40279 22.0001 6.75 22.0001Z"
        stroke="#08090A"
        strokeWidth={1.5}
      />
      <path
        id="Vector_4"
        d="M21.3678 2.43934L22.0602 3.1317C22.646 3.71748 22.646 4.66723 22.0602 5.25302L18.4328 8.94869C18.1475 9.23404 17.7825 9.42639 17.3858 9.50048L15.1376 9.98853C14.7827 10.0656 14.4666 9.75042 14.5426 9.39525L15.0212 7.15992C15.0952 6.76323 15.2876 6.39823 15.5729 6.11288L19.2465 2.43934C19.8323 1.85355 20.7821 1.85355 21.3678 2.43934Z"
        stroke="#08090A"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export default EditIcon;
